

Core.FinalisePayment = {
    init: function () {
        Core.FinalisePayment.Cache = {
            $termAndConditionLink: $('.termAndConditionPopup'),
            $btnAgreePopup: $('#btnAgreePopup'),
            $btnCancelPopup: $('#btnCancelPopup'),
            $termsCheckbox: $('#termsAndConditionsCheckbox'),
            $btnPay: $('#btnPayNow'),
        };

        this.setPopup();
        this.initTooltip();
        this.handleTacCheckbox();
        this.btnAgreeClickHandle();
        this.btnCancelClickHandle();
    },

    btnAgreeClickHandle: function () {
        Core.FinalisePayment.Cache.$btnAgreePopup.on('click', function (e) {
            e.stopPropagation();
            Core.FinalisePayment.checkTacCheckbox(true);
            Core.FinalisePayment.showPopup($('#tacPopup'), false);
        });
    },

    btnCancelClickHandle: function () {
        Core.FinalisePayment.Cache.$btnCancelPopup.on('click', function (e) {
            e.stopPropagation();
            Core.FinalisePayment.checkTacCheckbox(false);
            Core.FinalisePayment.showPopup($('#tacPopup'), false);
        });
    },

    handleTacCheckbox: function () {
        Core.FinalisePayment.Cache.$termsCheckbox.on('change', function (e) {
            //keep chekbox unchanged
            var isChecked = this.checked;
            this.checked = !isChecked;
            $.uniform.update('#termsAndConditionsCheckbox');

            Core.FinalisePayment.showPopup($('#tacPopup'), true);
        });
    },

    checkTacCheckbox: function (isSelected) {
        var _self = Core.FinalisePayment;

        _self.Cache.$termsCheckbox.prop('checked', isSelected);
        $.uniform.update('#termsAndConditionsCheckbox');

        _self.enablePayBtn(isSelected);
    },

    isTermChecked: function() {
        var _self = Core.FinalisePayment;

        return _self.Cache.$termsCheckbox.prop('checked');
    },

    enablePayBtn: function (doEnable) {
        $('#btn-pay').prop('disabled', !doEnable);

        if (typeof doEnable === "undefined" || doEnable === null) {
            doEnable = true;
        }

        var _self = Core.FinalisePayment;

        if (doEnable) _self.Cache.$btnPay.removeClass('disabled').prop('disabled', false);
        else _self.Cache.$btnPay.addClass('disabled').prop('disabled', true);
    },
    initTooltip: function() {
        $('#cvvTooltip').kendoTooltip({
            width: 200,
            position: "top",
            show: function(e) {
                this.popup.element.addClass('portal-tooltip text-center');
            }
        });
    },
    initPopup: function ($popup, title) {
        var _self = Core.FinalisePayment;
        var _width = 660,
            _height = 350;

        if (Core.IsMobile()) {
            _width = Core.Cache.$window.width();
        }

        $popup.kendoWindow({
            title: title,
            width: _width,
            visible: false,
            iframe: false,
            modal: true,
            resizable: false,
            actions: ["Close"],
            pinned: true,
            draggable: false,
            animation: false,
            appendTo: '#page-wrap'
        });

        var $closeBtn = $popup.find('.portal-modal__btn-close');

        if ($closeBtn) {
            $closeBtn.on('click', function () {
                _self.showPopup($popup, false);
            });
        }
    },

    showPopup: function ($popup, doShow) {
        doShow = doShow == undefined || null ? true : doShow; //set default to true/show

        var popupWindow = $popup.data("kendoWindow");

        if (doShow) {
            popupWindow.center().open();
        } else {
            popupWindow.close();
        }
    },

    setPopup: function () {
        var _self = Core.FinalisePayment;

        _self.initPopup($('#tacPopup'), "TERMS &amp; CONDITIONS");

        _self.Cache.$termAndConditionLink.on('click', function (e) {
            e.preventDefault();
            Core.FinalisePayment.showPopup($('#tacPopup'), true);
        });
    },
};


